/** Min inline size before title/message and actions sit side-by-side. */
export const blockingReasonWideMin = 420;

export const blockingReasonRowSx = {
  border: 1,
  borderRadius: 0.5,
  pl: 1.5,
  pr: 1,
  py: 1,
  alignItems: 'center',
} as const;

export const blockingReasonRowBackground = (color: 'error' | 'success') =>
  color === 'error' ? 'error.a3' : `${color}.backgroundSoft`;

export const blockingReasonRowBorderColor = (color: 'error' | 'success') =>
  color === 'error' ? 'error.borderRegular' : `${color}.borderRegular`;

export const blockingReasonIconSx = {
  color: 'error.solid',
} as const;

export const blockingReasonLinkSx = {
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  cursor: 'pointer',
  fontSize: '16px',
  fontWeight: 300,
  textDecoration: 'none',
  textTransform: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
} as const;

export const blockingReasonTertiaryButtonSx = {
  '&.MuiButton-tertiary': {
    bgcolor: '#ffffff !important',
    backgroundColor: '#ffffff !important',
    textTransform: 'uppercase',
    '&:hover': {
      bgcolor: '#ffffff !important',
      backgroundColor: '#ffffff !important',
      borderColor: 'neutral.4',
    },
    '&:active': {
      bgcolor: '#ffffff !important',
      backgroundColor: '#ffffff !important',
    },
    '&.MuiButton-loading': {
      bgcolor: '#ffffff !important',
      backgroundColor: '#ffffff !important',
    },
  },
} as const;